// extracted by mini-css-extract-plugin
module.exports = {"btn":"PasswordSetForm_btn__3LVLp","input":"PasswordSetForm_input__286OB"};